
const objectTypes = {
    CODE_EDITOR: 'content_question_qti2_code_editor',
    COMPILED_CODE_EDITOR: 'content_question_qti2_code_editor_compiled',
    COMPOSITE: 'content_question_qti2_composite_editor',
    CONTENT_BLOCK: 'content_question_qti2_content_block',
    CUSTOM_GEOGEBRA: 'content_question_qti2_custom_geogebra',
    DOCUMENT: 'content_nativehtml',
    DRAG_DROP: 'content_question_qti2_graphicgapmatch',
    EXTENDED_TEXT: 'content_question_qti2_extendedtext',
    EXTENDED_TEXT_MATH: 'content_question_qti2_extendedtext_math',
    FORM: 'content_question_qti2_composite_form',
    GAP_MATCH: 'content_question_qti2_gapmatch',
    GRAPHIC_GAP_MATCH: 'content_question_qti2_graphicgapmatch_v2',
    GRAPHIC_TEXT_ENTRY: 'content_question_qti2_text_entry_graphic',
    HOTSPOT: 'content_question_qti2_hotspot',
    INLINE_CHOICE: 'content_question_qti2_inline_choice',
    MATCHING: 'content_question_qti2_match',
    MATH_ENTRY: 'content_question_qti2_text_entry_math',
    WORD_FORMATION: 'content_question_qti2_text_entry_word_formation',
    MULTIPLE_CHOICE: 'content_question_qti2_multiple_choice',
    MULTIPLE_RESPONSE: 'content_question_qti2_multiple_response',
    ORAL: 'content_question_qti2_oral',
    SPEAKING: 'content_question_qti2_oral_speaking',
    TEXT_AREA: 'content_question_qti2_text_area',
    TEXT_ENTRY: 'content_question_qti2_text_entry',
    UPLOAD: 'content_question_qti2_upload',
    STIMULUS: 'content_question_qti2_stimulus',
    CATEGORY: {
        STIMULUS: 'stimulus',
        QUESTION: 'question',
        DOCUMENT: 'document',
        FORM: 'form',
        MATCH_IN_STIMULUS: 'match_in_stimulus',
    },
};

export default objectTypes;
